import styled, {css} from "styled-components";

export const FullScreenDiv = styled.div`
  width: 100vw;
  height: 100vh;
`;

export const FullWidthDiv = styled.div`
    width: 100%;        
`;

export const ColumnLayout = styled.div`
    display: flex;
    flex-direction: column;        
`;

export const RowLayout = styled.div`
    display: flex;
    flex-direction: row;        
`;

export const FloatingCenteredDiv = FullScreenDiv.extend`
  display: flex;
  justify-content: center;
  align-items: center;
`;


// WEBPACK FOOTER //
// ./src/components/styled.jsx